import { responsiveBreakpointsPx } from '@/constants/responsiveness';
import useViewportWidth from '@/hooks/useViewportWidth';

export const useViewportWidthName = (): keyof typeof responsiveBreakpointsPx => {
    const currentSize = useViewportWidth();
    const currentSizeName =
        Object.entries(responsiveBreakpointsPx)
            .sort(([, breakpointSizeA], [, breakpointSizeB]) => breakpointSizeB - breakpointSizeA)
            .find(([, breakpointSize]) => breakpointSize <= currentSize)?.[0] ?? 'sm';

    return currentSizeName as keyof typeof responsiveBreakpointsPx;
};
